var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 8,
    fill: "#5DBD72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5867 9.3131L14.2189 21.4173L10.4135 16.5C10.0901 16.0822 9.56582 16.0822 9.2425 16.5C8.91917 16.9178 8.91917 17.5953 9.2425 18.013L13.6335 23.6867C13.9568 24.1044 14.4812 24.1044 14.8045 23.6867L24.7575 10.8261C25.0808 10.4083 25.0808 9.73114 24.7575 9.31336C24.4342 8.89559 23.9103 8.89559 23.5867 9.3131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.cbba05d6e05d87b7d550844079b5c88d.svg";
export { ForwardRef as ReactComponent };